import React from 'react';
import Badge from './Badge';

const BadgeList = ({ badges, size = 'small', showTooltip = true, className = '' }) => {
  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className={`flex gap-1 ${className}`}>
      {badges.map(badge => (
        <Badge 
          key={badge.id} 
          badge={badge} 
          size={size} 
          showTooltip={showTooltip} 
        />
      ))}
    </div>
  );
};

export default BadgeList;
